import { useCustomReportContext } from 'providers/CustomReportProvider';
import { Col, Form, Row } from 'react-bootstrap';

const BasicDefinitionsStep = () => {
  const { reportData, updateReportData } = useCustomReportContext();

  const handleChange = (field, value) => {
    updateReportData({
      [field]: value
    });
  };

  return (
    <>
      <h5 className="mb-2">Definições Básicas</h5>
      <p className="text-muted mb-4 fs-11">
        Defina as informações básicas do seu relatório personalizado. O nome do
        relatório será exibido na lista de relatórios.
      </p>

      <Row>
        <Col md={12}>
          <Form.Group className="mb-3">
            <Form.Label>
              Nome do Relatório <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Digite o nome do relatório"
              value={reportData.name}
              onChange={e => handleChange('name', e.target.value)}
              required
            />
          </Form.Group>
        </Col>

        <Col md={12}>
          <Form.Group className="mb-3">
            <Form.Label>Descrição</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              placeholder="Digite a descrição do relatório"
              value={reportData.description}
              onChange={e => handleChange('description', e.target.value)}
            />
          </Form.Group>
        </Col>

        <Col md={12}>
          <Form.Group className="mb-3">
            <Form.Check
              type="switch"
              id="report-status"
              label="Ativo"
              checked={!reportData.inactive}
              onChange={e => handleChange('inactive', !e.target.checked)}
            />
          </Form.Group>
        </Col>
      </Row>
    </>
  );
};

export default BasicDefinitionsStep;
